import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class CountryRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/countries/list');
    }

    async getAll() {
        if (Cache.get('countries')) {
            return Cache.get('countries');
        }

        return this.setPerPage(1000).run().then((res) => {
            Cache.set('countries', res.data);
            return Cache.get('countries');
        });
    }
}
